import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c20361ae&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=c20361ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20361ae",
  null
  
)

export default component.exports